export default "__VITE_ASSET__D9Sqdc0C__"